import React from 'react';
import { Card, FormInstance } from 'antd';
import FormInput from 'components/FormInput';

import Value from 'components/Value';
import Title from 'components/Title';
import ModalController from 'components/ModalController';
import CorrespondantsModal from './CorrespondantsModal';
import GetLabel from 'DisplayFramework/components/GetLabel';
import CorrespondantsUserModal from './CorrespondantsUserModal';
export type CorrespondantsCardProps = {
  id: string;
  refetchTab: boolean;
  form: FormInstance;

};
const CorrespondantsCard = ({ id,refetchTab ,form}: CorrespondantsCardProps) => {
  return (
    <Card style={{ backgroundColor: '#f7f7f7' }} title={<GetLabel label="correspondents" style={{fontWeight:'bold',paddingLeft:15}}/>}>
   
        <table style={{ width: '100%' }}>
          <tbody>
            <tr style={{ backgroundColor: 'rgb(240 242 245)', height: '50px' }}>
              <th align="left">
                {' '}
                <Title level={5} comcode="Managment Section" />
              </th>
              <th align="left">
                <Title level={5} comcode="User Name" />
              </th>
              <th align="left">
                <Title level={5} comcode="Update Date" />
              </th>
            </tr>

            <tr style={{ height: '50px' }}>
              <th align="left">
              <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() => form.getFieldValue("tpsaleuserid")===null?setVisible(false):setVisible(true)}>
                        {' '}
                        <Title level={5} comcode="CorrSALE"></Title>
                      </a>
                      <CorrespondantsModal
                        refresh={refetchTab}
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        params={{ tpid: Number(id), type: 'SALE' }}
                      />
                    </>
                  )}
                </ModalController>
               
              </th>

              <td>
                <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() => setVisible(true)}>
                        {' '}
                        <FormInput name="tpsaleusername" noStyle>
                          <Value />
                        </FormInput>
                      </a>
                      <CorrespondantsUserModal
                        refresh={refetchTab}
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        id={form.getFieldValue("tpsaleuserid")}
                      />
                    </>
                  )}
                </ModalController>
              </td>

              <td>
                <FormInput name="tpsaleuserdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>
            <tr style={{ backgroundColor: 'rgb(240 242 245)', height: '50px' }}>
              <th align="left">
              <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() =>  form.getFieldValue("tpriskuserid")===null?setVisible(false):setVisible(true)}>
                        {' '}
                        <Title level={5} comcode="CorrRISK"></Title>
                      </a>
                      <CorrespondantsModal
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        params={{ tpid: Number(id), type: 'RISK' }}
                        refresh={refetchTab}
                      />
                    </>
                  )}
                </ModalController>
               
              </th>

              <td>
              <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() => setVisible(true)}>
                        {' '}
                        <FormInput name="tpriskusername" noStyle>
                          <Value />
                        </FormInput>
                      </a>
                      <CorrespondantsUserModal
                        refresh={refetchTab}
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        id={form.getFieldValue("tpriskuserid")}
                      />
                    </>
                  )}
                </ModalController>
              </td>

              <td>
                <FormInput name="tpriskuserdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>
            <tr style={{ height: '50px' }}>
              <th align="left">
              <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() =>  form.getFieldValue("tpbouserid")===null?setVisible(false):setVisible(true)}>
                        {' '}
                        <Title level={5} comcode="CorrBO"></Title>
                      </a>
                      <CorrespondantsModal
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        params={{ tpid: Number(id), type: 'BO' }}
                        refresh={refetchTab}
                      />
                    </>
                  )}
                </ModalController>
              </th>

              <td>
              <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() => setVisible(true)}>
                        {' '}
                        <FormInput name="tpbousername" noStyle>
                          <Value />
                        </FormInput>
                      </a>
                      <CorrespondantsUserModal
                        refresh={refetchTab}
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        id={form.getFieldValue("tpbouserid")}
                      />
                    </>
                  )}
                </ModalController>
              </td>

              <td>
                <FormInput name="tpbouserdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>
            <tr style={{ backgroundColor: 'rgb(240 242 245)', height: '50px' }}>
              <th align="left">
              <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() =>  form.getFieldValue("tprecuserid")===null?setVisible(false):setVisible(true)}>
                        {' '}
                        <Title level={5} comcode="CorrREC"></Title>
                      </a>
                      <CorrespondantsModal
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        params={{ tpid: Number(id), type: 'REC' }}
                        refresh={refetchTab}
                      />
                    </>
                  )}
                </ModalController>
                
              </th>

              <td>
              <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() => setVisible(true)}>
                        {' '}
                        <FormInput name="tprecusername" noStyle>
                          <Value />
                        </FormInput>
                      </a>
                      <CorrespondantsUserModal
                        refresh={refetchTab}
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        id={form.getFieldValue("tprecuserid")}
                      />
                    </>
                  )}
                </ModalController>
              </td>

              <td>
                <FormInput name="tprecuserdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>
            <tr
              style={{
                height: '50px',
                borderBottom: '2px solid rgb(240 242 245)',
              }}
            >
              <th align="left">
              <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() =>  form.getFieldValue("tplpuserid")===null?setVisible(false):setVisible(true)}>
                        {' '}
                        <Title level={5} comcode="CorrPL"></Title>
                      </a>
                      <CorrespondantsModal
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        params={{ tpid: Number(id), type: 'LP' }}
                        refresh={refetchTab}
                      />
                    </>
                  )}
                </ModalController>
               
              </th>

              <td>
              <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() => setVisible(true)}>
                        {' '}
                        <FormInput name="tplpusername" noStyle>
                          <Value />
                        </FormInput>
                      </a>
                      <CorrespondantsUserModal
                        refresh={refetchTab}
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                        }}
                        id={form.getFieldValue("tplpuserid")}
                      />
                    </>
                  )}
                </ModalController>
              </td>

              <td>
                <FormInput name="tplpuserdate" noStyle>
                  <Value />
                </FormInput>
              </td>
            </tr>
            
          </tbody>
        </table>
      </Card>
  
  );
};

export default CorrespondantsCard;
